// pushNotification.js

// Small helpers for storage
function getPushNotificationStore() {
  if (typeof window === "undefined") return {};
  try {
    const stored = window.sessionStorage.getItem("pushNotification");
    return stored ? JSON.parse(stored) : {};
  } catch (e) {
    console.warn("Unable to read pushNotification from sessionStorage:", e);
    return {};
  }
}

function setPushNotificationStore(store) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem("pushNotification", JSON.stringify(store));
  } catch (e) {
    console.warn("Unable to write pushNotification to sessionStorage:", e);
  }
}

// Check if browser supports Notifications + Service Worker
function isBrowserNotificationSupported() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  return "Notification" in window && "serviceWorker" in navigator;
}

export const handlePushNotification = (
  notificationName,
  notificationHeader,
  notificationBody,
  actionButtonText,
  notificationRedirectUrl,
  showMultipleTimes = false
) => {
  return
  // If notifications are not supported, just bail out gracefully
  if (!isBrowserNotificationSupported()) {
    console.log("Browser does not support Notification API or Service Workers.");
    return;
  }

  let pushNotification = getPushNotificationStore();

  let notificationShown = false;
  if (!showMultipleTimes) {
    const lastShownTimestamp = pushNotification[notificationName];
    if (lastShownTimestamp) {
      const lastShownDate = new Date(lastShownTimestamp).toDateString();
      const currentDate = new Date().toDateString();
      if (lastShownDate === currentDate) {
        notificationShown = true;
      }
    }
  }

  const showAndRecordNotification = (registration) => {
    try {
      registration.showNotification(notificationHeader, {
        body: notificationBody,
        icon: "https://ms.purplepatch.online/logo/quizard.png",
        requireInteraction: false,
        actions: [
          {
            action: "redirect",
            title: actionButtonText,
          },
        ],
        data: {
          redirectPath: notificationRedirectUrl,
        },
      });

      pushNotification[notificationName] = Date.now();
      setPushNotificationStore(pushNotification);
    } catch (e) {
      console.error("Error showing notification:", e);
    }
  };

  if (!notificationShown) {
    // We already know Notification exists here because of isBrowserNotificationSupported()
    if (Notification.permission === "granted") {
      navigator.serviceWorker.ready
        .then(showAndRecordNotification)
        .catch((error) => {
          console.error("Service Worker error:", error);
        });
    } else if (Notification.permission !== "denied") {
      // Request permission safely
      Promise.resolve(Notification.requestPermission())
        .then((permission) => {
          if (permission === "granted") {
            navigator.serviceWorker.ready
              .then(showAndRecordNotification)
              .catch((error) => {
                console.error("Service Worker error:", error);
              });
          }
        })
        .catch((error) => {
          console.error("Notification permission request failed:", error);
        });
    }
  }
};

export function isNotificationShown(notificationName) {
  return true;
  let pushNotification = getPushNotificationStore();
  const lastShownTimestamp = pushNotification[notificationName];
  if (lastShownTimestamp) {
    const lastShownDate = new Date(lastShownTimestamp).toDateString();
    const currentDate = new Date().toDateString();
    if (lastShownDate === currentDate) {
      return true;
    }
  }
  return false;
}
